/*
 * Vajihi Labs - Email Signature Builder
 * Uploads a validated logo file to the hosted upload endpoint
 * (signature-builder.vajihilabs.com/api/upload-logo) so Customize can offer
 * a real hosted URL instead of asking the user to paste one into Settings.
 * A relative fetch, so it's same-origin by construction: in production the
 * task pane is served from signature-builder.vajihilabs.com, so this reaches
 * the real endpoint; on localhost (dev) or if the endpoint is ever
 * unreachable, the request simply fails and callers fall back to
 * local-preview-only behavior — never a hard error surfaced to the user.
 */

export interface LogoUploadResult {
  ok: boolean;
  url?: string;
  reason?: string;
}

export async function uploadLogo(file: File): Promise<LogoUploadResult> {
  try {
    const body = new FormData();
    body.append("logo", file);
    const response = await fetch("/api/upload-logo", { method: "POST", body });
    let payload: { ok?: boolean; url?: string; reason?: string } = {};
    try {
      payload = await response.json();
    } catch {
      // No/invalid JSON body — handled by the ok-check below.
    }
    if (!response.ok || !payload.ok || !payload.url) {
      return { ok: false, reason: payload.reason || "Couldn't upload the logo — using a local preview instead." };
    }
    return { ok: true, url: payload.url };
  } catch {
    return { ok: false, reason: "Couldn't reach the upload service — using a local preview instead." };
  }
}
